import { render, staticRenderFns } from "./PlusPlan.vue?vue&type=template&id=004afe22&"
import script from "./PlusPlan.vue?vue&type=script&lang=js&"
export * from "./PlusPlan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports